import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { adminApi, getAdminToken, setAdminToken, clearAdminToken } from './adminApi';

const AdminAuthContext = createContext({ admin: null, loading: true });

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!getAdminToken()) { setAdmin(null); return; }
    try {
      const data = await adminApi('/admin/auth/me');
      setAdmin(data.admin);
    } catch {
      clearAdminToken();
      setAdmin(null);
    }
  }, []);

  useEffect(() => { (async () => { await refresh(); setLoading(false); })(); }, [refresh]);

  function login(token, adminData) { setAdminToken(token); setAdmin(adminData); }
  function logout() { clearAdminToken(); setAdmin(null); }

  return (
    <AdminAuthContext.Provider value={{ admin, loading, login, logout, refresh }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export const useAdminAuth = () => useContext(AdminAuthContext);
